export default {
  penColor: 'rgb(033, 033, 033)',
  height: 250,
  width: 400,
};
